var map = {
	"./Img-01.jpg": 721,
	"./Img-02.jpg": 722,
	"./Img-03.jpg": 723,
	"./Img-05.jpg": 724,
	"./Img-07.jpg": 725,
	"./K.png": 726,
	"./b.png": 727,
	"./blog-grid/author_img.png": 284,
	"./blog-grid/blog_list1.jpg": 728,
	"./blog-grid/blog_list2.jpg": 729,
	"./blog-grid/blog_list3.jpg": 730,
	"./blog-grid/blog_list4.jpg": 731,
	"./blog-grid/blog_single.png": 285,
	"./blog-grid/comment1.png": 286,
	"./blog-grid/comment2.png": 287,
	"./blog-grid/post_1.jpg": 732,
	"./blog-grid/post_2.jpg": 733,
	"./blog-grid/post_3.jpg": 734,
	"./blog-grid/post_4.jpg": 735,
	"./blog-grid/post_img_1.png": 288,
	"./blog-grid/post_img_2.png": 289,
	"./blog-grid/post_img_3.png": 290,
	"./br_logo.png": 736,
	"./breadcrumb/banner_bg.png": 737,
	"./breadcrumb/service.png": 738,
	"./breadcrumb/service_details.png": 739,
	"./breadcrumb/service_details_one.png": 740,
	"./cart1.jpg": 741,
	"./cart2.jpg": 742,
	"./erp-home/action_img.png": 90,
	"./erp-home/background.png": 291,
	"./erp-home/banner_shap.png": 292,
	"./erp-home/cloud-computing.png": 293,
	"./erp-home/cloud_01.png": 91,
	"./erp-home/cloud_02.png": 92,
	"./erp-home/cloud_03.png": 93,
	"./erp-home/cloud_04.png": 94,
	"./erp-home/cloud_05.png": 95,
	"./erp-home/cloud_06.png": 96,
	"./erp-home/crm_img1.jpg": 294,
	"./erp-home/crm_img2.jpg": 295,
	"./erp-home/crm_img3.jpg": 296,
	"./erp-home/erp_dashboard.jpg": 97,
	"./erp-home/erp_icon1.png": 297,
	"./erp-home/erp_icon2.png": 298,
	"./erp-home/erp_icon3.png": 299,
	"./erp-home/erp_icon4.png": 300,
	"./erp-home/erp_icon5.png": 301,
	"./erp-home/erp_icon6.png": 302,
	"./erp-home/growth.png": 303,
	"./erp-home/img/01.png": 98,
	"./erp-home/img/02.png": 99,
	"./erp-home/img/03.png": 100,
	"./erp-home/img/04.png": 101,
	"./erp-home/img/05.png": 102,
	"./erp-home/img/06.png": 103,
	"./erp-home/img/07.png": 104,
	"./erp-home/img/08.png": 105,
	"./erp-home/img/09.png": 106,
	"./erp-home/img/10.png": 107,
	"./erp-home/img/11.png": 108,
	"./erp-home/img/12.png": 109,
	"./erp-home/img/13.png": 110,
	"./erp-home/img/14.png": 111,
	"./erp-home/img/15.png": 112,
	"./erp-home/img/16.png": 113,
	"./erp-home/img/17.png": 114,
	"./erp-home/img/18.png": 115,
	"./erp-home/img/19.png": 116,
	"./erp-home/img/20.png": 117,
	"./erp-home/quote.png": 304,
	"./erp-home/rocket.png": 118,
	"./erp-home/settings1.png": 305,
	"./erp-home/shape.png": 306,
	"./erp-home/testimonial_img.jpg": 307,
	"./erp-home/testimonial_img2.jpg": 308,
	"./error_bg.png": 743,
	"./favicon.png": 744,
	"./home-chat/Messages.jpg": 309,
	"./home-chat/Messages.png": 119,
	"./home-chat/book.png": 120,
	"./home-chat/box.png": 121,
	"./home-chat/chat.png": 122,
	"./home-chat/chat_01.png": 310,
	"./home-chat/chat_02.png": 311,
	"./home-chat/chat_icon.png": 312,
	"./home-chat/cloud.png": 123,
	"./home-chat/dashboard.png": 313,
	"./home-chat/dot.png": 314,
	"./home-chat/get_started_bg.png": 315,
	"./home-chat/john.png": 124,
	"./home-chat/left_leaf.png": 125,
	"./home-chat/live_chat.png": 126,
	"./home-chat/mobile.png": 127,
	"./home-chat/panguin_img_one.png": 128,
	"./home-chat/panguin_img_three.png": 129,
	"./home-chat/panguin_img_two.png": 130,
	"./home-chat/pluse.png": 131,
	"./home-chat/richard.png": 132,
	"./home-chat/right_leaf.png": 133,
	"./home-chat/skyp_1.png": 316,
	"./home-chat/skyp_2.png": 317,
	"./home-chat/support_dashboard.jpg": 318,
	"./home-chat/triangle.png": 134,
	"./home-chat/video_icon.png": 319,
	"./home-event/about.jpg": 135,
	"./home-event/banner_bg.jpg": 136,
	"./home-event/chat.png": 320,
	"./home-event/conference.jpg": 29,
	"./home-event/digital.jpg": 44,
	"./home-event/dot.png": 321,
	"./home-event/image_01.jpg": 322,
	"./home-event/image_02.jpg": 323,
	"./home-event/image_03.jpg": 324,
	"./home-event/image_04.jpg": 325,
	"./home-event/image_05.jpg": 326,
	"./home-event/image_06.jpg": 327,
	"./home-event/instragram1.jpg": 328,
	"./home-event/instragram2.jpg": 329,
	"./home-event/instragram3.jpg": 330,
	"./home-event/instragram4.jpg": 331,
	"./home-event/instragram5.jpg": 332,
	"./home-event/instragram6.jpg": 333,
	"./home-event/leader.png": 334,
	"./home-event/logo_09.jpg": 335,
	"./home-event/logo_10.jpg": 336,
	"./home-event/logo_11.jpg": 337,
	"./home-event/logo_12.jpg": 338,
	"./home-event/marker.png": 137,
	"./home-event/marketing.jpg": 45,
	"./home-event/meetup.png": 339,
	"./home-event/price_shap.png": 340,
	"./home-event/promo.jpg": 138,
	"./home-event/team1.jpg": 341,
	"./home-event/team2.jpg": 342,
	"./home-event/team3.jpg": 343,
	"./home-event/timer.png": 139,
	"./home-security/about_img_1.jpg": 344,
	"./home-security/about_img_2.jpg": 345,
	"./home-security/apple_icon.png": 346,
	"./home-security/banner.png": 140,
	"./home-security/leaf_clients1.png": 141,
	"./home-security/leaf_clients2.png": 142,
	"./home-security/mackbook.png": 143,
	"./home-security/padlock.png": 144,
	"./home-security/real-estate.png": 347,
	"./home-security/rocket.png": 348,
	"./home-security/security_1 2.png": 349,
	"./home-security/security_1.png": 350,
	"./home-security/security_2 2.png": 351,
	"./home-security/security_2.png": 352,
	"./home-security/security_3.png": 353,
	"./home-security/security_4.png": 354,
	"./home-security/shap.png": 145,
	"./home-security/sheld_bg.png": 146,
	"./home-security/shield.png": 147,
	"./home-security/windows_icon.png": 355,
	"./home-software/analytices1.png": 356,
	"./home-software/analytices2.png": 357,
	"./home-software/analytices3.png": 358,
	"./home-software/analytices4.png": 359,
	"./home-software/analytices5.jpg": 360,
	"./home-software/analytices6.jpg": 361,
	"./home-software/analytices7.jpg": 362,
	"./home-software/analytices8.jpg": 363,
	"./home-software/case.png": 364,
	"./home-software/down_bg.png": 365,
	"./home-software/elements_five.png": 366,
	"./home-software/elements_four.png": 367,
	"./home-software/elements_one.png": 368,
	"./home-software/elements_six.png": 369,
	"./home-software/elements_three.png": 370,
	"./home-software/elements_two.png": 371,
	"./home-software/line_02.png": 372,
	"./home-software/logo_01.png": 148,
	"./home-software/logo_02.png": 149,
	"./home-software/logo_03.png": 150,
	"./home-software/logo_04.png": 151,
	"./home-software/logo_05.png": 152,
	"./home-software/logo_06.png": 153,
	"./home-software/logo_07.png": 154,
	"./home-software/logo_08.png": 155,
	"./home-software/logo_09.png": 373,
	"./home-software/logo_10.png": 374,
	"./home-software/logo_11.png": 375,
	"./home-software/logo_12.png": 376,
	"./home-software/mackbook.png": 377,
	"./home-software/pie.png": 378,
	"./home-software/setup_img1.png": 379,
	"./home-software/setup_img2.png": 380,
	"./home-software/setup_img3.png": 381,
	"./home-software/shap_3.png": 382,
	"./home-software/shap_one.png": 383,
	"./home-software/shap_two.png": 384,
	"./home-tracking/activity_icon.png": 156,
	"./home-tracking/aliexpress.png": 385,
	"./home-tracking/amazon.png": 386,
	"./home-tracking/analyze_icon.png": 157,
	"./home-tracking/apple.png": 387,
	"./home-tracking/computer_tracking_img.jpg": 388,
	"./home-tracking/crismas.png": 389,
	"./home-tracking/cta.png": 158,
	"./home-tracking/cta_pattern_bg.jpg": 390,
	"./home-tracking/google.png": 391,
	"./home-tracking/left-dot.png": 392,
	"./home-tracking/month.png": 393,
	"./home-tracking/right-dot.png": 394,
	"./home-tracking/tesla.png": 395,
	"./home-tracking/time_icon.png": 159,
	"./home-tracking/tracking_banner_img.png": 160,
	"./home-tracking/watch_1.png": 396,
	"./home-tracking/windows.png": 397,
	"./home2/action_bg.png": 745,
	"./home2/control.png": 398,
	"./home2/controller.png": 399,
	"./home2/curtain.png": 400,
	"./home2/mobile.png": 401,
	"./home2/smartap.png": 402,
	"./home2/smartswitch.png": 403,
	"./home3/action_image.png": 404,
	"./home3/dimond.png": 405,
	"./home3/logo_01.png": 58,
	"./home3/logo_02.png": 161,
	"./home3/logo_03.png": 162,
	"./home3/logo_04.png": 59,
	"./home3/logo_05.png": 60,
	"./home3/p_feature1.png": 406,
	"./home3/prototype_banner_img.png": 407,
	"./home3/prototype_banner_img2.png": 408,
	"./home3/psd.png": 409,
	"./home3/saas.png": 410,
	"./home3/tab.png": 411,
	"./home4/action_shap.png": 412,
	"./home4/author_img.png": 413,
	"./home4/banner_bg.png": 163,
	"./home4/banner_img.png": 164,
	"./home4/divider.png": 165,
	"./home4/dot.png": 166,
	"./home4/icon01.png": 414,
	"./home4/icon02.png": 415,
	"./home4/icon3.png": 416,
	"./home4/icon_04.png": 417,
	"./home4/icon_05.png": 418,
	"./home4/icon_shape1.png": 419,
	"./home4/icon_shape2.png": 420,
	"./home4/icon_shape3.png": 421,
	"./home4/icon_shape4.png": 422,
	"./home4/process_1.png": 423,
	"./home4/process_2.png": 424,
	"./home4/process_3.png": 425,
	"./home4/process_4.png": 426,
	"./home4/process_5.png": 427,
	"./home4/shape.png": 428,
	"./home4/team1.jpg": 61,
	"./home4/team2.jpg": 37,
	"./home4/work1.png": 429,
	"./home4/work2.png": 430,
	"./home4/work3.png": 431,
	"./home5/01.jpg": 167,
	"./home5/02.jpg": 168,
	"./home5/03.jpg": 169,
	"./home5/banner_img.png": 170,
	"./home5/design1.png": 171,
	"./home5/design2.png": 172,
	"./home5/featured_bg_shape.png": 432,
	"./home5/featured_img1.png": 173,
	"./home5/icon1.png": 433,
	"./home5/icon2.png": 434,
	"./home5/icon3.png": 435,
	"./home5/icon_shape.png": 174,
	"./home5/php.jpg": 175,
	"./home5/shap_tecture.png": 436,
	"./home6/dashboard.jpg": 176,
	"./home6/featured_img_one.jpg": 177,
	"./home6/featured_img_two.jpg": 178,
	"./home6/feedback_img_one.png": 437,
	"./home6/feedback_img_three.png": 438,
	"./home6/feedback_img_two.png": 439,
	"./home6/logo_01.png": 440,
	"./home6/logo_02.png": 441,
	"./home6/logo_03.png": 442,
	"./home6/logo_04.png": 443,
	"./home6/logo_05.png": 444,
	"./home6/shape-1.png": 179,
	"./home6/shape2.png": 180,
	"./home6/trust_img.png": 445,
	"./home6/trust_img2.png": 446,
	"./home7/01.png": 447,
	"./home7/02.png": 448,
	"./home7/03.png": 449,
	"./home7/app.png": 450,
	"./home7/banner.png": 746,
	"./home7/google_icon.png": 451,
	"./home7/iPhoneX2.png": 452,
	"./home7/iPhonex.png": 453,
	"./home7/screenshot1.png": 62,
	"./home7/screenshot2.png": 454,
	"./home7/screenshot3.png": 181,
	"./home7/screenshot4.png": 455,
	"./home7/screenshot5.png": 456,
	"./home7/team_01.jpg": 747,
	"./home7/team_02.jpg": 748,
	"./home7/team_03.jpg": 749,
	"./home7/team_04.jpg": 750,
	"./home7/testimonial_author_img.png": 63,
	"./home7/text_one.png": 457,
	"./home7/text_three.png": 458,
	"./home7/text_two.png": 459,
	"./home8/banner_img.png": 460,
	"./home8/dot.png": 751,
	"./home8/fact.png": 752,
	"./home8/service_item_03.png": 753,
	"./home9/featured_img.png": 182,
	"./home9/featured_img_two.png": 183,
	"./home9/flag.png": 461,
	"./home9/footer.png": 462,
	"./home9/icon1.png": 184,
	"./home9/icon2.png": 46,
	"./home9/icon3.png": 185,
	"./home9/icon4.png": 463,
	"./home9/icon5.png": 464,
	"./home9/icon6.png": 465,
	"./home9/icon7.png": 466,
	"./home9/icon8.png": 467,
	"./home9/icon_shape.png": 47,
	"./home9/icon_shape_two.png": 468,
	"./home9/logo1.png": 186,
	"./home9/logo2.png": 187,
	"./home9/logo3.png": 188,
	"./home9/logo4.png": 189,
	"./home9/logo5.png": 190,
	"./home9/logo6.png": 191,
	"./home9/logo7.png": 192,
	"./home9/logo8.png": 193,
	"./home9/mac.png": 194,
	"./home9/map.png": 469,
	"./home9/shape-footer.png": 470,
	"./home9/shape.png": 195,
	"./home9/shape_two.png": 471,
	"./home9/testimonial_img.png": 196,
	"./home9/testimonial_img2.png": 472,
	"./home9/triangle_bottom.png": 473,
	"./home9/triangle_top.png": 474,
	"./hosting/action_img.png": 475,
	"./hosting/business1.png": 476,
	"./hosting/business2.png": 477,
	"./hosting/h_blog1.jpg": 478,
	"./hosting/h_blog2.jpg": 479,
	"./hosting/hosting-image.png": 197,
	"./hosting/hosting_action_bg.png": 198,
	"./hosting/icon1.png": 480,
	"./hosting/icon10.png": 481,
	"./hosting/icon2.png": 482,
	"./hosting/icon3.png": 483,
	"./hosting/icon4.png": 484,
	"./hosting/icon5.png": 485,
	"./hosting/icon6.png": 486,
	"./hosting/icon7.png": 487,
	"./hosting/icon8.png": 488,
	"./hosting/icon9.png": 489,
	"./hosting/line_01.png": 199,
	"./hosting/line_02.png": 200,
	"./hosting/line_03.png": 201,
	"./hosting/line_04.png": 202,
	"./hosting/line_05.png": 203,
	"./hosting/line_06.png": 204,
	"./hosting/line_07.png": 205,
	"./hosting/line_08.png": 206,
	"./hosting/map.png": 490,
	"./hosting/region_map.png": 491,
	"./login_img.png": 754,
	"./login_img2.png": 755,
	"./logo.png": 64,
	"./logo1.png": 269,
	"./logo2.png": 42,
	"./logo2x.png": 756,
	"./logo3.png": 492,
	"./logo4.png": 757,
	"./logo7.png": 758,
	"./logo8.png": 759,
	"./mega-menu-img/Prototyping_Tool.jpg": 760,
	"./mega-menu-img/analytices.jpg": 761,
	"./mega-menu-img/coming_img.jpg": 762,
	"./mega-menu-img/erp.jpg": 763,
	"./mega-menu-img/home-animation.jpg": 764,
	"./mega-menu-img/home-chat.jpg": 765,
	"./mega-menu-img/home-event.jpg": 766,
	"./mega-menu-img/home-security.jpg": 767,
	"./mega-menu-img/home-track.jpg": 768,
	"./mega-menu-img/home1.jpg": 769,
	"./mega-menu-img/home10.jpg": 770,
	"./mega-menu-img/home11.jpg": 771,
	"./mega-menu-img/home12.jpg": 772,
	"./mega-menu-img/home13.jpg": 773,
	"./mega-menu-img/home14.jpg": 774,
	"./mega-menu-img/home15.jpg": 775,
	"./mega-menu-img/home16.jpg": 776,
	"./mega-menu-img/home17.jpg": 777,
	"./mega-menu-img/home2.jpg": 778,
	"./mega-menu-img/home3.jpg": 779,
	"./mega-menu-img/home4.jpg": 780,
	"./mega-menu-img/home5.jpg": 781,
	"./mega-menu-img/home6.jpg": 782,
	"./mega-menu-img/home7.jpg": 783,
	"./mega-menu-img/home8.jpg": 784,
	"./mega-menu-img/home9.jpg": 785,
	"./mega-menu-img/hosting.jpg": 786,
	"./mega-menu-img/icon/app-d.png": 787,
	"./mega-menu-img/icon/blup.png": 788,
	"./mega-menu-img/pos.jpg": 789,
	"./mega-menu-img/saas2-slider.png": 790,
	"./mega-menu-img/support.jpg": 791,
	"./new-home/aircon.png": 207,
	"./new-home/back_bg.png": 493,
	"./new-home/banner.png": 208,
	"./new-home/briteverify.png": 494,
	"./new-home/campfire.png": 209,
	"./new-home/cctv.png": 210,
	"./new-home/cleanrobot.png": 211,
	"./new-home/curtains.png": 212,
	"./new-home/doorcam.png": 213,
	"./new-home/doorlock.png": 214,
	"./new-home/email.png": 215,
	"./new-home/fans.png": 216,
	"./new-home/kissmetrics.png": 217,
	"./new-home/lights.png": 218,
	"./new-home/metorik.png": 219,
	"./new-home/nicereply-1.png": 220,
	"./new-home/p-1.png": 221,
	"./new-home/p-2.png": 222,
	"./new-home/p-3.png": 223,
	"./new-home/tab.png": 224,
	"./new-home/tab_2.png": 225,
	"./new-home/tab_3.png": 226,
	"./new-home/ticket-support.png": 227,
	"./new-home/tree-left.png": 228,
	"./new-home/tree-right.png": 229,
	"./new-home/tree.png": 230,
	"./new-home/update.png": 231,
	"./new-home/webhooks.png": 232,
	"./new/01.png": 792,
	"./new/0111.png": 495,
	"./new/02.png": 793,
	"./new/0222.png": 496,
	"./new/03.png": 794,
	"./new/04.png": 795,
	"./new/05.png": 796,
	"./new/06.png": 797,
	"./new/app_screen.png": 798,
	"./new/blog/blog_grid_1.jpg": 497,
	"./new/blog/blog_grid_2.jpg": 498,
	"./new/blog/blog_grid_3.jpg": 499,
	"./new/blog/blog_grid_4.jpg": 500,
	"./new/blog/blog_grid_5.jpg": 501,
	"./new/blog/blog_grid_6.jpg": 502,
	"./new/blog/blog_grid_7.jpg": 503,
	"./new/blog/blog_grid_8.jpg": 504,
	"./new/case/case_01.jpg": 799,
	"./new/case/case_02.jpg": 800,
	"./new/case/case_03.jpg": 801,
	"./new/case/case_04.jpg": 802,
	"./new/case/case_05.jpg": 803,
	"./new/case/case_06.jpg": 804,
	"./new/case/case_07.jpg": 805,
	"./new/case/case_08.jpg": 806,
	"./new/case/case_09.jpg": 807,
	"./new/case/case_10.jpg": 808,
	"./new/case/case_11.jpg": 809,
	"./new/case/case_12.jpg": 810,
	"./new/case/case_details_01.jpg": 811,
	"./new/case/case_details_02.jpg": 812,
	"./new/case/case_details_03.jpg": 813,
	"./new/case/parallax.png": 814,
	"./new/coming_soon_bg.png": 815,
	"./new/company.jpg": 816,
	"./new/cup.png": 505,
	"./new/digital_img.png": 817,
	"./new/error.png": 506,
	"./new/features_01.png": 818,
	"./new/feedback_shap.png": 819,
	"./new/home-split/contact.png": 820,
	"./new/iPhoneX.png": 33,
	"./new/icon.png": 821,
	"./new/icon/icon1.png": 822,
	"./new/icon/icon2.png": 823,
	"./new/icon2.png": 824,
	"./new/icon3.png": 825,
	"./new/intregration_1.png": 507,
	"./new/intregration_2.png": 508,
	"./new/intregration_3.png": 509,
	"./new/intregration_4.png": 510,
	"./new/laptop.png": 511,
	"./new/laptop_two.png": 826,
	"./new/leaf.png": 512,
	"./new/line_01.png": 513,
	"./new/line_02.png": 514,
	"./new/line_03.png": 515,
	"./new/logo_01.png": 827,
	"./new/logo_02.png": 828,
	"./new/logo_03.png": 829,
	"./new/logo_04.png": 830,
	"./new/logo_05.png": 831,
	"./new/member_01.jpg": 832,
	"./new/new_shape.png": 833,
	"./new/phone.png": 516,
	"./new/price_bg.png": 834,
	"./new/shape_bg.png": 835,
	"./new/solution_01.jpg": 836,
	"./new/solution_02.jpg": 837,
	"./new/startup_banner_bg.png": 838,
	"./new/startup_banner_img.png": 517,
	"./new/startup_shap.png": 839,
	"./new/tab_shape_bg.png": 840,
	"./new/testimonial_bg.png": 841,
	"./new/testimonial_bg_shap.png": 842,
	"./new/testimonial_bg_two.png": 843,
	"./new/video_bg.jpg": 844,
	"./new/video_img_01.png": 845,
	"./new/video_img_02.jpg": 846,
	"./new/web_image.jpg": 34,
	"./portfolio-details/pr_details1.jpg": 518,
	"./portfolio-details/pr_details2.jpg": 519,
	"./portfolio-details/pr_details3.jpg": 520,
	"./portfolio-details/pr_details4.jpg": 521,
	"./portfolio/2-columns/grid1.jpg": 522,
	"./portfolio/2-columns/grid2.jpg": 523,
	"./portfolio/2-columns/grid3.jpg": 524,
	"./portfolio/2-columns/grid4.jpg": 525,
	"./portfolio/2-columns/grid5.jpg": 526,
	"./portfolio/2-columns/grid6.jpg": 527,
	"./portfolio/2-columns/grid7.jpg": 528,
	"./portfolio/2-columns/grid8.jpg": 529,
	"./portfolio/3-columns/3_col_1.jpg": 530,
	"./portfolio/3-columns/3_col_10.jpg": 531,
	"./portfolio/3-columns/3_col_11.jpg": 532,
	"./portfolio/3-columns/3_col_12.jpg": 533,
	"./portfolio/3-columns/3_col_2.jpg": 534,
	"./portfolio/3-columns/3_col_3.jpg": 535,
	"./portfolio/3-columns/3_col_4.jpg": 536,
	"./portfolio/3-columns/3_col_5.jpg": 537,
	"./portfolio/3-columns/3_col_6.jpg": 538,
	"./portfolio/3-columns/3_col_7.jpg": 539,
	"./portfolio/3-columns/3_col_8.jpg": 540,
	"./portfolio/3-columns/3_col_9.jpg": 541,
	"./portfolio/full-width/full_1.jpg": 542,
	"./portfolio/full-width/full_10.jpg": 543,
	"./portfolio/full-width/full_11.jpg": 544,
	"./portfolio/full-width/full_12.jpg": 545,
	"./portfolio/full-width/full_2.jpg": 546,
	"./portfolio/full-width/full_3.jpg": 547,
	"./portfolio/full-width/full_4.jpg": 548,
	"./portfolio/full-width/full_5.jpg": 549,
	"./portfolio/full-width/full_6.jpg": 550,
	"./portfolio/full-width/full_7.jpg": 551,
	"./portfolio/full-width/full_8.jpg": 552,
	"./portfolio/full-width/full_9.jpg": 553,
	"./pos/High-end-all-in-one-dual-screen.png": 847,
	"./pos/b_dashboard.png": 848,
	"./pos/cash-register.png": 849,
	"./pos/chat.png": 850,
	"./pos/credit-card.png": 851,
	"./pos/delivery-truck.png": 852,
	"./pos/ezgif-1-997e5035cba4.png": 853,
	"./pos/fotter_shap.png": 854,
	"./pos/icon1.png": 855,
	"./pos/icon2.png": 856,
	"./pos/icon3.png": 857,
	"./pos/item1.png": 858,
	"./pos/item2.png": 859,
	"./pos/item3.png": 860,
	"./pos/laptop.png": 861,
	"./pos/leaf-left.png": 554,
	"./pos/leaf-right.png": 555,
	"./pos/mailbox.png": 862,
	"./pos/man.png": 556,
	"./pos/pattern_01.png": 863,
	"./pos/pattern_02.png": 864,
	"./pos/people.png": 557,
	"./pos/pos.png": 865,
	"./pos/pos_about_img.png": 866,
	"./pos/pos_blog_1.png": 867,
	"./pos/pos_blog_2.png": 868,
	"./pos/pos_blog_3.png": 869,
	"./pos/pos_slideshow1.jpg": 870,
	"./pos/pos_slideshow2.jpg": 871,
	"./pos/pos_slideshow3.jpg": 872,
	"./pos/shape.png": 873,
	"./pos/shape_bg.png": 874,
	"./pos/statistics.png": 875,
	"./pos/tab_pattern.png": 876,
	"./pos/wave_two.png": 877,
	"./pos/women.png": 558,
	"./price/one.png": 878,
	"./price/three.png": 879,
	"./price/two.png": 880,
	"./process/ASAN-logo-icon.png": 881,
	"./process/Avast_Antivirus.png": 882,
	"./process/UTorrent_(logo).png": 883,
	"./process/btFMmsoh.png": 884,
	"./process/logo-slack.png": 885,
	"./process/png-logo-design.png": 886,
	"./qoute.png": 887,
	"./saas/map.png": 888,
	"./seo/bike.png": 889,
	"./seo/car.png": 890,
	"./seo/cloud.png": 559,
	"./seo/cloud_bg.png": 891,
	"./seo/features_img.png": 277,
	"./seo/features_img_two.png": 280,
	"./seo/footer_bg.png": 892,
	"./seo/icon1.png": 274,
	"./seo/icon2.png": 275,
	"./seo/icon3.png": 279,
	"./seo/icon4.png": 278,
	"./seo/icon5.png": 276,
	"./seo/image.png": 273,
	"./seo/logo_01.png": 560,
	"./seo/logo_02.png": 561,
	"./seo/logo_03.png": 562,
	"./seo/logo_04.png": 563,
	"./seo/logo_05.png": 564,
	"./seo/logo_06.png": 565,
	"./seo/logo_07.png": 566,
	"./seo/logo_08.png": 567,
	"./seo/logo_09.png": 568,
	"./seo/shap.png": 893,
	"./seo/studies_img_one.jpg": 282,
	"./seo/studies_img_three.jpg": 89,
	"./seo/studies_img_two.jpg": 283,
	"./seo/triangle_one.png": 270,
	"./seo/triangle_three.png": 272,
	"./seo/triangle_two.png": 271,
	"./svg.svg": 894,
	"./teams/team_01.jpg": 569,
	"./teams/team_02.jpg": 570,
	"./teams/team_03.jpg": 571,
	"./teams/team_04.jpg": 572,
	"./teams/team_10.jpg": 573,
	"./teams/team_12.jpg": 574,
	"./teams/team_5.jpg": 575,
	"./teams/team_6.jpg": 576,
	"./teams/team_7.jpg": 577,
	"./teams/team_8.jpg": 578,
	"./teams/team_9.jpg": 579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;